import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace(
  'city-of-inglewood-general-municipal-election-measure-at-4348'
).catch(console.error);
